<template lang="html">
  <div id="wangEditor" class="editor">
    <div ref="toolbar" class="toolbar"></div>
    <div ref="editor" class="text"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
export default {
  name: 'editoritem',
  data() {
    return {
      editor: null,
      info_: null
    }
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    first: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    content: {
      handler(value) {
        if (this.editor && this.first) {
          this.editor.txt.html(value)
          this.$emit('inputValue', false)
        }
      },
      deep: true,
      immediate: true
    },
    disabled: {
      handler() {
        if (this.editor) {
          if (this.disabled) {
            this.editor.disable()
          } else {
            this.editor.enable()
          }
        }
      },
      deep: true,
      immediate: true
    }
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },
  mounted() {
    this.seteditor()
  },
  beforeDestroy() {
    // 销毁编辑器
    this.editor.destroy()
    this.editor = null
  },
  methods: {
    intervelEditor() {
      // this.editor.txt.html(this.content)
      if (this.disabled) {
        this.editor.disable()
      } else {
        this.editor.enable()
      }
    },
    seteditor() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const that = this
      this.editor = new E(this.$refs.toolbar, this.$refs.editor)
      // 配置 onchange 回调函数
      this.editor.config.onchange = function (newHtml) {
        that.$emit('onblur', newHtml)
      }
      // 配置触发 onchange 的时间频率，默认为 200ms
      this.editor.config.onchangeTimeout = 500 // 修改为 500ms
      this.editor.config.uploadImgShowBase64 = true
      this.editor.create()
      this.editor.txt.html(this.content)
      this.editor.config.onblur = function (newHtml) {
        that.$emit('onblur', newHtml)
      }
      this.intervelEditor()
    }
  }
}
</script>

<style lang="css">
.editor {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 0;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
  min-height: 200px;
}
</style>
